module.exports = __webpack_public_path__ + "img/right-leg.f320f8b4.png";